import { render, staticRenderFns } from "./ProductTagging.vue?vue&type=template&id=f7232584&scoped=true&"
import script from "./ProductTagging.vue?vue&type=script&lang=js&"
export * from "./ProductTagging.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagging.vue?vue&type=style&index=0&id=f7232584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7232584",
  null
  
)

export default component.exports